import { graphql } from '@api/generated';

export const serviceUserFieldsFragment = graphql(`
  fragment ServiceUserFields on User {
    id
    contactCenterUserId
    name
    email
    personalLine {
      phoneNumber
    }
  }
`);

export const serviceUserStatsFragment = graphql(`
  fragment ServiceUserStats on User {
    availabilityActivityStatus {
      availabilityStatus
      activityStatus
    }
    stats {
      lastActionAt
      lastHandledAt
      lastIdleAt
      loginAt
      totalSessions
      offeredSessions
      missedSessions
      avgCallTime
    }
  }
`);
